import { render, staticRenderFns } from "./taskApprove.vue?vue&type=template&id=0c7ef864&scoped=true"
import script from "./taskApprove.vue?vue&type=script&lang=js"
export * from "./taskApprove.vue?vue&type=script&lang=js"
import style0 from "./taskApprove.vue?vue&type=style&index=0&id=0c7ef864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ef864",
  null
  
)

export default component.exports